<template>
  <div class="student-detail-tab-card">
    <v-tabs v-model="tab">
      <v-tab>
        <span>Chăm sóc định kỳ</span>
      </v-tab>
      <v-tab>
        <span>Kết quả học tập TUTOR</span>
      </v-tab>
      <v-tab>
        <span>Kết quả học tập DUO</span>
      </v-tab>
      <v-tab>
        <span>Log</span>
      </v-tab>
      <v-tab>
        <span>Ticket</span>
      </v-tab>
      <v-tab v-show="recordDetail && (recordDetail.type_curriculum == TYPE_CURRICULUM_OBJ.ONLINE || recordDetail.type_curriculum == TYPE_CURRICULUM_OBJ.IELTS_COURSE)">
        <span>Công việc</span>
      </v-tab>
      <v-tab>
        Note
      </v-tab>
      <v-tab>
        Hoạt động
      </v-tab>
      <v-tab-item>
        <NoteCard
          :recordDetail="recordDetail"
          :listCareOfSt="listCareOfSt"
          :listProduct="listProduct"
          :listTypeCustomer="listTypeCustomer"
          class="mt-2"></NoteCard>
        <CareHistoryTab
          :listCareHistory="listCareHistory"
        ></CareHistoryTab>
      </v-tab-item>
      <v-tab-item>
        <TutorStudyResultTab :is-exist-self-study="isExistSelfStudy"></TutorStudyResultTab>
      </v-tab-item>
      <v-tab-item>
        <StudyResultTabNew class="mt-2" :userId="studentBlendedTutorDetail.lms_core_user_id" :subjectId="activeProgramSubjectId"></StudyResultTabNew>
<!--        <DuoStudyResult></DuoStudyResult>-->
      </v-tab-item>
      <v-tab-item>
        <LogTableBlendedVue></LogTableBlendedVue>
      </v-tab-item>
      <v-tab-item>
        <TicketTab></TicketTab>
      </v-tab-item>
      <v-tab-item v-show="recordDetail && (recordDetail.type_curriculum == TYPE_CURRICULUM_OBJ.ONLINE || recordDetail.type_curriculum == TYPE_CURRICULUM_OBJ.IELTS_COURSE)">
        <BlendedTutorTaskTab :taskType="taskType" type-screen="blended" :curriculumId="activeCurriculumId" :lmsCoreUserId="studentBlendedTutorDetail.lms_core_user_id"/>
      </v-tab-item>
      <v-tab-item>
        <NoteTab ref="noteTab" :id="studentId"></NoteTab>
      </v-tab-item>
      <v-tab-item>
        <ActivityTab ref="activityTab" :id="studentId"></ActivityTab>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import StudyResultTabNew from '@/modules/duo_care/components/detail/StudyResultTabNew.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
// import DuoStudyResult from '@/modules/student_detail_bt/components/DuoStudyResult.vue';
import TutorStudyResultTab from '@/modules/student_detail_bt/components/TutorStudyResultTab.vue';
import CareHistoryTab from '@/modules/student_detail_bt/components/CareHistoryTab.vue';
import NoteCard from '@/modules/student_detail_bt/components/NoteCard.vue';
import TicketTab from '@/modules/student_detail_bt/components/TicketTab.vue';
import BlendedTutorTaskTab from '@/modules/student_detail_bt/components/BlendedTutorTaskTab.vue';
import NoteTab from '@/modules/student_care/components/NoteTab.vue';
import ActivityTab from '@/modules/student_care/components/ActivityTab.vue';
import StudentCareServices from '../../../services/StudentCareServices';
import { TYPE_CALL_STATUS, TYPE_CURRICULUM_OBJ } from '../../../helpers/constant';
import {
  getModuleCare, moduleCareColor, PREFIX_CARE_MODULE, STUDENT_DETAIL_BLENDED_TAB_INDEX,
} from '../constant';
import LogTableBlendedVue from './LogTableBlended.vue';

export default {
  name: 'CareHistoryCard',
  components: {
    ActivityTab,
    NoteTab,
    BlendedTutorTaskTab,
    CareHistoryTab,
    TutorStudyResultTab,
    // DuoStudyResult,
    StudyResultTabNew,
    NoteCard,
    LogTableBlendedVue,
    TicketTab,
  },
  props: {
    recordDetail: {
      type: Object,
      default: () => ({
        // lms_core_user_id: 9559,
        // type_customer_care: 4,
        // type_curriculum: 'online',
      }),
    },
  },
  data() {
    return {
      TYPE_CURRICULUM_OBJ,
      STUDENT_DETAIL_BLENDED_TAB_INDEX,
      taskType: null,
      listCareOfSt: [],
      listTypeCustomer: [
        { id: 1, name: 'Chăm sóc định kỳ' },
      ],
      listProduct: [],
      listProgramObj: {},
      listAllCareHistory: [],
      listCareHistory: [],
      isExistSelfStudy: false,
      tab: 0,
    };
  },
  async created() {
    this.taskType = this.$route.query.taskType ? this.$route.query.taskType : null;
    await Promise.all([
      this.getListProgram(),
      this.getListStatusForBlended(),
    ]);
    this.getListCareOfSt();
    this.getAllHistoryCare(this.recordDetail);
    // Bus
    Bus.$on('filter-list-care-history', (params) => {
      this.getHistoryCareFilter(params);
    });
    Bus.$on('reload-list-care-history', async (params) => {
      await this.getAllHistoryCare(this.recordDetail);
      if (!_.isEmpty(params)) {
        this.getHistoryCareFilter(params);
      }
    });
    Bus.$on('reload-list-product', (params) => {
      const careCurrentSelected = this.listCareOfSt.find((e) => e.id === params.id);
      if (careCurrentSelected) {
        careCurrentSelected.call_status_id = params.call_status_id;
        careCurrentSelected.color = this.mapCallStatus[careCurrentSelected?.call_status_id]?.color;
        const callStatusName = this.mapCallStatus[careCurrentSelected?.call_status_id].callStatus;
        const arrayName = careCurrentSelected.name.split(' - ');
        arrayName.pop(); arrayName.push(callStatusName);
        careCurrentSelected.name = arrayName.join(' - ');
      }
    });
    this.$nextTick(() => {
      if (this.$route.query.log === 'true') {
        this.scrollToBottom();
        this.tab = 3;
      }
    });
  },
  methods: {
    ...mapActions('contact_status', ['getListStatusForBlended']),
    async getListCareOfSt() {
      const res = await StudentCareServices.fgGetListCareBlender({
        obj: 'routine',
        attrs: [
          'id', 'contact_id', 'lms_core_user_id', 'student_id', 'full_name', 'customer_id', 'call_id',
          'call_status_id', 'type_customer_care', 'type_curriculum', 'curriculum_id', 'subject_id',
          'subject_id_list', 'is_main_curriculum',
        ],
        'filters[$eq__lms_core_user_id]': this.recordDetail?.lms_core_user_id,
      });
      if (res?.success) {
        const rawCareStudent = res?.data;
        if (rawCareStudent.some((e) => e.type_curriculum === TYPE_CURRICULUM_OBJ.IELTS_COURSE)) {
          this.isExistSelfStudy = true;
        }
        const tutorRecords = rawCareStudent.filter((e) => e.is_main_curriculum === 1 && e.type_curriculum === TYPE_CURRICULUM_OBJ.ONLINE).map((i) => ({
          ...i,
          stt: [TYPE_CALL_STATUS.GIA_HAN, TYPE_CALL_STATUS.CHUYEN_SALES].includes(i?.type_customer_care) ? 2 : 1,
        })).sort((a, b) => a.stt - b.stt);
        const tutorExtendRecord = rawCareStudent.filter((e) => e.is_main_curriculum === 1 && [TYPE_CALL_STATUS.GIA_HAN, TYPE_CALL_STATUS.CHUYEN_SALES].includes(+e.type_customer_care) && e.type_curriculum === TYPE_CURRICULUM_OBJ.ONLINE);
        const duoExtendRecord = rawCareStudent.filter((e) => e.type_curriculum === 'duo' && e.type_customer_care === 2);
        this.listCareOfSt = [...tutorRecords, ...duoExtendRecord].map((item) => {
          const typeCustomerCareName = [TYPE_CALL_STATUS.GIA_HAN, TYPE_CALL_STATUS.CHUYEN_SALES].includes(item?.type_customer_care) ? 'Gia hạn' : 'CSĐK';
          const typeCurriculumName = item?.type_curriculum === TYPE_CURRICULUM_OBJ.ONLINE ? 'Tutor' : 'Duo';
          const curriculumName = item?.curriculum_id ? _.get(this.listProgramObj, `[${item.curriculum_id}].title`, '') : '';
          const callName = this.replaceCallName(this.mapCallStatus[item?.call_status_id]?.callType);
          const callStatusName = this.mapCallStatus[item.call_status_id].callStatus;
          const { color } = this.mapCallStatus[item.call_status_id];
          const name = [`${typeCustomerCareName} ${typeCurriculumName}`, curriculumName, callName, callStatusName].filter((e) => e).join(' - ');
          return {
            ...item,
            name,
            color,
          };
        });
        this.listProduct = _.cloneDeep(this.listCareOfSt).map((item) => {
          const curriculumName = item?.curriculum_id ? _.get(this.listProgramObj, `[${item.curriculum_id}].title`, '') : 'Duo';
          return {
            ...item,
            name: `${curriculumName}`,
          };
        });
        if (tutorExtendRecord?.length || duoExtendRecord?.length) {
          this.listTypeCustomer.push({
            id: 2,
            name: 'Gia hạn',
          });
        }
      }
    },
    async getListProgram() {
      const res = await StudentCareServices.fgGetListCrmBlended({
        obj: 'program',
        attrs: [
          'id', 'title', 'code',
        ],
        'filters[$eq__status]': 1,
      });
      if (res?.success) {
        // eslint-disable-next-line no-unused-expressions
        res?.data.forEach((e) => {
          this.listProgramObj[e.id] = e;
        });
      }
    },
    async getAllHistoryCare(params) {
      const res = await StudentCareServices.fgGetListCareBlender({
        obj: 'call-histories-detail',
        attrs: ['id', 'created_name', 'note', 'call_name', 'call_status_name', 'call_status_id', 'lms_core_user_id',
          'call_id', 'created_at', 'created_by', 'type_customer_care', 'type_blended', 'type_curriculum', 'curriculum_id'],
        'filters[$eq__lms_core_user_id]': params.lms_core_user_id,
        'filters[$ne__type_customer_care]': 'null',
        'sorts[created_at]': 'desc',
      });
      if (res?.success) {
        this.listAllCareHistory = res.data.map((item) => {
          const moduleCare = getModuleCare(item);
          let curriculumName = '';
          if (item.curriculum_id) curriculumName = this.listProgramObj[item.curriculum_id]?.title;
          else if (item.type_blended === 2 && item.type_curriculum === TYPE_CURRICULUM_OBJ.DUO) {
            curriculumName = PREFIX_CARE_MODULE.DUO;
          }
          const name = [PREFIX_CARE_MODULE[moduleCare], curriculumName, item.created_name].filter((e) => e).join(' - ');
          const callAndCallStatus = `${[TYPE_CALL_STATUS.C0, TYPE_CALL_STATUS.CHAM_SOC_DINH_KY].includes(item.type_customer_care) ? 'CSĐK' : 'Gia hạn'}
            - Mốc ${this.getCallName(item)}
            - ${item.call_status_name ? item.call_status_name : this.mapCallStatus[item.call_status_id]?.callStatus}`;
          const { color } = this.mapCallStatus[item.call_status_id];
          return {
            ...item,
            name,
            callAndCallStatus,
            color,
            backgroundColor: moduleCareColor[moduleCare],
          };
        });
        this.listCareHistory = _.cloneDeep(this.listAllCareHistory);
      }
    },
    getHistoryCareFilter(params) {
      if (!params) {
        this.listCareHistory = [];
        return;
      }
      if (_.isEmpty(params)) {
        this.listCareHistory = _.cloneDeep(this.listAllCareHistory);
        return;
      }
      this.listCareHistory = this.listAllCareHistory.filter((e) => e.lms_core_user_id === params.lms_core_user_id && e.type_curriculum === params.type_curriculum
        && e.type_customer_care === params.type_customer_care);
      if (params.type_curriculum === TYPE_CURRICULUM_OBJ.ONLINE && params.curriculum_id) {
        this.listCareHistory = this.listCareHistory.filter((e) => e.curriculum_id === params.curriculum_id);
      }
    },
    getCallName(item) {
      if (item.type_blended) {
        return item.call_name ? this.replaceCallName(item.call_name) : this.replaceCallName(this.mapCallStatus[item.call_status_id]?.callType);
      }
      return item.call_name ? item.call_name : this.mapCallStatus[item.call_status_id]?.callType;
    },
    replaceCallName(callName) {
      if (!callName) return '';
      return callName.replace('TA', 'BT');
    },
    scrollToBottom() {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },
  },
  computed: {
    ...mapGetters('contact_status', ['mapCallStatus']),
    ...mapState('student_detail_bt', ['studentBlendedTutorDetail', 'activeCurriculumId', 'studentId', 'activeProgramSubjectId']),
  },
  watch: {
    tab(val) {
      switch (val) {
        case STUDENT_DETAIL_BLENDED_TAB_INDEX.NOTE:
          this.$refs.noteTab.getListNotes();
          break;
        case STUDENT_DETAIL_BLENDED_TAB_INDEX.ACTIVITY:
          this.$refs.activityTab.getListActivity();
          break;
        default:
          break;
      }
    },
  },
  beforeDestroy() {
    Bus.$off('filter-list-care-history');
    Bus.$off('reload-list-care-history');
    Bus.$off('reload-list-product');
  },
};
</script>

<style scoped lang="scss">
.student-detail-tab-card {
  background: white;
  border-radius: 12px;
  width: 98%;
  padding: 0px 16px;
}
@media screen and (max-width: 1440px) {
 .student-detail-tab-card {
  font-size: 12px !important;
  span {
   font-size: 12px !important;
  }
 }
}
</style>
